const homeUrlPath = '/home';

const researchPathStart = '/research';

const localStorageLastUrl = 'Cmrad::LastUrlUsedByUser';

const sessionStorageHandledFirstLoad = 'Cmrad::HandledFirstLoad';

const handleURLChange = () => {
  const lastVisitedUrl = localStorage.getItem(localStorageLastUrl);
  const currentUrl = window.location.href;
  const isHomePath = currentUrl.endsWith(homeUrlPath);
  const isFirstHomePageLoad = sessionStorage.getItem(sessionStorageHandledFirstLoad);

  if (!isHomePath && isResearchPlatformURL(currentUrl)) {
    localStorage.setItem(localStorageLastUrl, currentUrl);
  }

  if (!isHomePath && !isResearchPlatformURL(currentUrl) && lastVisitedUrl) {
    localStorage.removeItem(localStorageLastUrl);
  }

  if (isHomePath && isFirstHomePageLoad) {
    sessionStorage.setItem(sessionStorageHandledFirstLoad, 'false');
  }
};

const isResearchPlatformURL = (currentUrl) => {
  const parsedUrl = new URL(currentUrl).pathname;

  // Check if the first segment after the domain matches the target path (without leading slash)
  return parsedUrl.startsWith(researchPathStart);
};

export const navigationHandler = (currentUrl, inertia) => {
  if (!currentUrl) return;
  // Check if it's the first load in a new session
  if (!sessionStorage.getItem(sessionStorageHandledFirstLoad)) {
    const lastVisitedUrl = localStorage.getItem(localStorageLastUrl);
    // Set the flag to indicate the first load is handled
    sessionStorage.setItem(sessionStorageHandledFirstLoad, 'true');
    // Redirect only if the last visited URL is different from the current URL
    if (
      isResearchPlatformURL(lastVisitedUrl) &&
      currentUrl !== lastVisitedUrl &&
      !lastVisitedUrl.endsWith(homeUrlPath)
    ) {
      inertia.visit(lastVisitedUrl);
    }
  }
};

export const setupURLChangeHandler = () => {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    handleURLChange();
  };

  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    handleURLChange();
  };

  window.onpopstate = handleURLChange;
  handleURLChange();
};
